import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import axios from "axios";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import CircularProgress from "@material-ui/core/CircularProgress";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";

export default function RoomItem(item) {
  const parseHtml = require("html-react-parser");

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    /*   paper: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }, */
    grid: {
      backgroundColor: item.bg,
      paddingLeft: "1%",
      paddingTop: "0.3%",
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      // border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    paperCancelacion: {
      backgroundColor: "white",
      border: "1px solid #FE5215",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    reservar: {
      background: "#016AA2",
      color: "white",
      fontFamily: "MontserratSemiBold",
      textTransform: "capitalize",
      "&:hover": {
        background: "#FE5215",
        color: "white",
      },
    },
    reservarNaranja: {
      background: "#FE5215",
      color: "white",
      fontFamily: "MontserratSemiBold",
      textTransform: "capitalize",
      "&:hover": {
        background: "#016AA2",
        color: "white",
      },
    },
    Amount: {
      color: "black",
    },
    MealsPlan: {
      color: "#757575",
      fontStyle: "oblique",
    },
    TituloHotel: {
      color: "#016AA2",
      fontFamily: "MontserratSemiBold",
      // fontWeight: 'bolder'
    },
    TituloHotelP: {
      color: "#FE5215",
      textAlign: "center",
      fontWeight: "bolder",
    },
    TituloHabitacion: {
      color: "#3f51b5",
      fontFamily: "MontserratSemiBold",
      fontWeight: 'bold'
    },
    TituloHabitacionP: {
      color: "#757575",
      textAlign: "center",
      fontWeight: "bolder",
    },
  }));
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [policy, setPolicy] = React.useState([]);

  const handleOpen = () => {
    setPolicy([]);

    const url = "https://webtravel2-online.com/APIhoteles/api/PoliticasServiciosRetrieve?idEncabezado=" +
    item.IDEncabezado +
    "&idCombinacion=" +
    item.IDCombinacion +
    "&Operador=" +
    item.Operador;
    axios
      .get(
        url
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.length !== 0) {
          setPolicy(response.data[0].Condiciones);
          console.log(response.data);
        } else {
         
          var politicas = [];
          if (item.Operador === "ATOM") {
           politicas.push({
            Cargo: "",
            Descripcion: "",
            Fecha: "Favor consultar con Atom Travel",
            Habitacion: "",
            Tipo: "",
            })
          } else {
            politicas.push({
            Cargo: "se cobrará 100% del total de noches",
            Descripcion: "fff",
            Fecha: "ERROR EN WS ----- En gastos desde la reserva",
            Habitacion: "",
            Tipo: "",
          })
        }
          console.log("epaepaepa");
          console.log(politicas);
          setPolicy(politicas);
        }
      })
      .catch((error) => {
        console.log(error);
        console.log(item.Operador);
        var politicas = [];
        if (item.Operador === "ATOM") {
          politicas.push({
          Cargo: "",
          Descripcion: "",
          Fecha: "Favor consultar con Atom Travel",
          Habitacion: "",
          Tipo: "",
          })
        } else {
          politicas.push({
          Cargo: "se cobrará 100% del total de noches",
          Descripcion: "fff",
          Fecha: "ERROR EN WS ----- En gastos desde la reserva",
          Habitacion: "",
          Tipo: "",})
        }
      
        setPolicy(politicas);
        console.log(error);
        //setOpen(false);
      }); //
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const bookingClick = (hotelSelected) => {
    console.log("bookingClick-RoomItem");
    console.log(item);
    item.onClick(
      item.hotelOperador,
      item.IDCombinacion,
      item.Operador,
      item.IDEncabezado,
      item.token
    );
  };

  const GetWeekDay = (fecha) => {
    const d = new Date(fecha.substring(0, 4),fecha.substring(6, 4)-1,fecha.substring(8, 6));

const weekday = new Array(7);
weekday[0] = "Domingo";
weekday[1] = "Lunes";
weekday[2] = "Martes";
weekday[3] = "Miercoles";
weekday[4] = "Jueves";
weekday[5] = "Viernes";
weekday[6] = "Sábado";

return  weekday[d.getDay()] + " " + fecha.substring(8, 6)+"/"+fecha.substring(6, 4)+"/"+fecha.substring(0, 4)  ;
  };

  return (
    <React.Fragment>
     
        <Grid container spacing={1} className={classes.grid}>
          <Grid item sm={8}>
            <Typography
              variant="subtitle1"
              gutterBottom
              className={classes.TituloHabitacion}
            >
              {parseHtml(item.DescripcionCombinacion)}
      
            </Typography>
            <Box className={classes.MealsPlan}>
              <Typography variant="body2" gutterBottom>
              {parseHtml(item.Regimen)}
              </Typography>
            </Box>
          </Grid>
          <Grid item sm={2} container direction="column" justify="center">
          <Typography variant="subtitle2" gutterBottom>
              {GetWeekDay(item.fechainicio)}
              </Typography>
            <Link href="#" onClick={handleOpen}>
              <Typography variant="caption" gutterBottom>
                Políticas de cancelación
              </Typography>
            </Link>
          </Grid>         
          <Grid
            item
            sm={2}
            container
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Typography
              variant="subtitle2"
              gutterBottom
              className={classes.Amount}
            >
              {item.moneda} {Number(item.montototal).toFixed(2)}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              className={classes.reservarNaranja}
              disableElevation
              size="small"
              onClick={bookingClick}
            >
              {/*       <Typography component="div" variant="body2">
              <Box letterSpacing={1}>RESERVAR</Box>
            </Typography> */}
              {item.mensajeReserva}
            </Button>
          </Grid>
        </Grid>
  
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paperCancelacion}>
            {policy.length > 0 ? (
              <React.Fragment>
                <Box display="flex" p={0} style={{ width: "100%" }}>
                  <Box flexGrow={1}>
                    <Typography variant="h6" className={classes.TituloHotel}>
                      Políticas de Cancelación
                    </Typography>
                  </Box>
                  <Box p={0} display="flex" alignItems="center">
                    <Link href="#" onClick={handleClose}>
                      <CloseIcon fontSize="mediun" style={{color: "#016AA2"}} />
                    </Link>
                  </Box>
                </Box>

                <Box
                  display="flex"
                  justifyContent="center"
                  verticalAlign="center"
                  flexDirection="column"
                  m={1}
                  p={1}
                  css={{ width: "100%" }}
                >
                  <Typography variant="h6" className={classes.TituloHotelP}>
                    {item.HotelNombre}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    className={classes.TituloHabitacionP}
                  >
                    {parseHtml(item.DescripcionCombinacion)}
                  </Typography>
                </Box>
                <Divider variant="middle" className={classes.separador} />
                {/*  <Typography variant="h6" className={classes.TituloHotel}>
                  {item.HotelNombre}
                </Typography>
                <Typography
                  variant="subtitle1"
                  className={classes.TituloHabitacion}
                >
                  {item.DescripcionCombinacion}
                </Typography> */}
                <List className={classes.root}>
                  <Box
                    display="flex"
                    justifyContent="center"
                    verticalAlign="center"
                    flexDirection="column"
                    m={1}
                    p={1}
                    css={{ width: "100%" }}
                  >
                    {policy.map((resultX, i) => (
                      <ListItem>
                        <ListItemText
                          key={i}
                          disableTypography
                          primary={
                            <Typography
                              type="body2"
                              style={{ color: "gray", textAlign: "center" }}
                            >
                              {resultX.Fecha}
                            </Typography>
                          }
                          secondary={
                            <Typography
                              type="body2"
                              style={{ color: "black", textAlign: "center" }}
                            >
                              {resultX.Cargo}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))}
                  </Box>
                </List>
              </React.Fragment>
            ) : (
              <CircularProgress />
            )}
          </div>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}
